import { render, staticRenderFns } from "./ProDetails.vue?vue&type=template&id=7138f5c4&scoped=true"
import script from "./ProDetails.vue?vue&type=script&lang=ts"
export * from "./ProDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7138f5c4",
  null
  
)

export default component.exports